import React from 'react';

import { ToggleButton } from '@change/ds-core-ui';
import { HeartFilledIcon, HeartIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import type { PartialComment } from './hooks/useCommentLikes';
import { useCommentLikes } from './hooks/useCommentLikes';

export const CommentLikes: React.FC<Props> = ({ comment, onLikeToggled, className }) => {
	const {
		data: { liked, likes, likesCount, a11yLabel },
		actions: { toggleLiked },
	} = useCommentLikes({ comment, onLikeToggled });

	return (
		// Using variant="standard" with custom icons to control icon size (x-small).
		// The "like" variant uses hardcoded default-sized icons.
		<ToggleButton
			className={cn('w-8', className)}
			variant="standard"
			isSelected={liked}
			counter={likesCount === 0 ? undefined : likes}
			aria-label={a11yLabel}
			onClick={toggleLiked}
			pinnedIcon={<HeartFilledIcon size="x-small" className="text-icon-error" />}
			unpinnedIcon={<HeartIcon size="x-small" />}
			data-testid="toggle-like-button"
			data-qa="comment-toggle-like"
		/>
	);
};

type Props = Readonly<{
	comment: PartialComment;
	onLikeToggled?: (liked: boolean) => void;
	className?: string;
}>;
